import { render, staticRenderFns } from "./mb_about_us.vue?vue&type=template&id=442d19e0&scoped=true&"
import script from "./mb_about_us.vue?vue&type=script&lang=js&"
export * from "./mb_about_us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d19e0",
  null
  
)

export default component.exports